<template>
  <div class="inside">

    
    
       <div class="evento-child" v-for="intervento in finterventi(evento.id)" :key="intervento.id">
         <intervento-dettaglio :evento="intervento" />
       </div>


    
  </div>
</template>

<script>
import interventoOspiti from './Intervento-ospiti.vue'
import interventoDettaglio from './Intervento-dettaglio.vue'

var moment = require('moment');
moment.locale('en');
export default {
  name: 'programma-dettaglio',
  components: {
    interventoDettaglio
    ,interventoOspiti
  },
  props:{
    eventoid: '' 
  },
  created () {
    console.log("Arrivo al Programma-evento.vue con sezione  "+this.eventoid)
  },
  computed: {
      evento: function () {
          //console.log('àààààààààààààààààààààààààààààààààààààààààààààààààààààààà')
          for (let item of this.$teras._programma){
            //console.log(item.id+' == '+ this.eventoid)
            if(item.id == this.eventoid)
                return item
          }
      }
      
  },
  methods:{
    finterventi(id){
        var isFilter = []
        for (let item of this.$teras._programma){
            //console.log(item)
            if(item.parent == id)
                isFilter.push(item)
        }
        return isFilter
    }
  },
  filters: {
    datetime (value,formato) {
        return moment(value).format(formato)
    },
    citta (value) {
        if(value!=''){
            value = ' ('+value+')'
        }
        return value
    }
  }
}
</script>


<style>
.evento{
    margin-bottom:40px;
}span.ospite:not(:last-child):after {
    content:', ';
}

</style>
